import { FC, ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useRecoilState } from 'recoil'

import { LanguageHelper, UiHelper, UrlHelper } from '../../utils/helpers'
import MetadataService from '../../services/MetadataService'
import { checkVersionAndRefresh } from '../../utils/helpers/VersionHelper'
import TenantService from '../../services/TenantService'
import { LANGUAGE_SELECTION_DATA } from '../../utils/constants/Countries'
import { LogoAnimation } from '../atoms'
import { metadataAtom } from '../../recoil/atoms/metadataAtom'
import { CARRIER_URLS } from '../../routers/urls'

interface IPublic {
  children?: ReactNode
}

const Common: FC<IPublic> = ({ children }) => {
  const { pathname, search } = useLocation()
  const [metadataState, setMetadataState] = useRecoilState(metadataAtom)
  const { data: user } = TenantService.getCurrentUser(false, false)
  const { data } = MetadataService.getStaticMetaFile()
  const { data: countries, isValidating } = MetadataService.getCountries()

  const setLanguageFromQuery = () => {
    const lang = UrlHelper.getQueryParam(search, 'lang')
    const langIsValid = LANGUAGE_SELECTION_DATA.find(item => item.value === lang)
    lang && langIsValid && LanguageHelper.change(lang)
  }

  useEffect(() => {
    if (!data?.version) {
      return
    }

    checkVersionAndRefresh(data?.version)
  }, [data?.version])

  // useEffect(() => {
  //   LanguageHelper.change(user?.data?.language || LanguageHelper.get())
  // }, [user])

  useEffect(() => {
    // TODO: Remove this logic
    if (countries?.data?.length > 0 && metadataState?.countries?.length === 0) {
      setMetadataState(prev => ({
        countries: [...prev.countries, ...countries?.data],
      }))
    }
  }, [countries])

  useEffect(() => {
    UiHelper.saveVisitingInfo()
    setLanguageFromQuery()
  }, [])

  if (!!isValidating) return <LogoAnimation />

  return <>{children}</>
}

export default Common
